import { useMemo } from 'react';
import type { MultiValue } from 'react-select';
import { useTeamGroups } from '../../../../hooks/api';
import type { SelectOption } from '../../../../types';
import { selectOptionFactory } from '../../../../utils';
import { LabeledSelect, FormLabelVariant } from '../../../generic';

type TeamGroupSelectorProps = {
  onTeamGroupSelect: (selectedTeamGroups: MultiValue<SelectOption<number>>) => void;
};

const TeamGroupSelector = (props: TeamGroupSelectorProps) => {
  const { data: teamGroups, isLoading: isLoadingTeamGroups } = useTeamGroups();
  const teamGroupOptions = useMemo(() => {
    return teamGroups
      ?.map(teamGroup => selectOptionFactory(teamGroup.id, teamGroup.name)) || [];
  }, [teamGroups]);

  return (
    <LabeledSelect
      id="team-group-select"
      label="Team Group (optional)"
      placeholder="Select team group(s)"
      options={teamGroupOptions}
      onChange={props.onTeamGroupSelect}
      variant={FormLabelVariant.Filter}
      isDisabled={isLoadingTeamGroups}
      isMulti
    />
  );
};

export default TeamGroupSelector;
